var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCompletedShipment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 4.89474C2 3.8483 2.89543 3 4 3H8H13H14H20C20.5523 3 21 3.42415 21 3.94737C21 4.47059 20.5523 4.89474 20 4.89474H19.0198L19.9055 9.09005C20.0663 9.20993 20.2087 9.35397 20.3262 9.51889L21.6577 11.3877C21.8808 11.7008 22 12.0699 22 12.4477V17.2105C22 18.257 21.1046 19.1053 20 19.1053H19.6632C19.1015 20.2255 17.8962 21 16.5 21C15.1038 21 13.8985 20.2255 13.3368 19.1053H13H9.66318C9.10145 20.2255 7.8962 21 6.5 21C5.05127 21 3.80812 20.1661 3.27617 18.9774C2.52938 18.7026 2 18.0151 2 17.2105V4.89474ZM14 4.89474H16.9998C16.9999 4.956 17.0063 5.01816 17.0194 5.08053L17.7802 8.68421H14V4.89474ZM12 4.89474H8L7.99965 4.89474H4V11.5263H12V4.89474ZM12 13.4211H4V15.3636C4.63526 14.7495 5.52066 14.3684 6.5 14.3684C8.26324 14.3684 9.72194 15.6037 9.96456 17.2105H12V13.4211ZM14 15.3636C14.6353 14.7495 15.5207 14.3684 16.5 14.3684C18.2632 14.3684 19.7219 15.6037 19.9646 17.2105H20V12.4477L18.6685 10.5789H14V15.3636ZM15 17.6842C15 16.8994 15.6716 16.2632 16.5 16.2632C17.3284 16.2632 18 16.8994 18 17.6842C18 18.469 17.3284 19.1053 16.5 19.1053C15.6716 19.1053 15 18.469 15 17.6842ZM6.5 16.2632C5.67157 16.2632 5 16.8994 5 17.6842C5 18.469 5.67157 19.1053 6.5 19.1053C7.32843 19.1053 8 18.469 8 17.6842C8 16.8994 7.32843 16.2632 6.5 16.2632Z",
    fill: "#483D3D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompletedShipment);
export default __webpack_public_path__ + "static/media/completed_shipment.b8910ff2a5f0eb0badcaf4e441f8a59b.svg";
export { ForwardRef as ReactComponent };